import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination } from '@mui/material';
import React, { useState } from 'react';
import ModalResultados from './modal';
import './tabla.css';

function IndicadoresTable({ data }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedData = data.reduce((acc, area) => {
    area.children.forEach((tema) => {
      tema.children.forEach((indicador) => {
        acc.push({
          area: area.label,
          tema: tema.label,
          indicador: indicador.label,
          id: indicador.indicadorid,
          url: indicador.url,
        });
      });
    });
    return acc;
  }, []);

  const startIndex = page * rowsPerPage;
  const paginatedResults = paginatedData.slice(startIndex, startIndex + rowsPerPage);

  return (
    <div>
      <TableContainer component={Paper} style={{ maxHeight: 510 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell className='encabezado'>Área</TableCell>
              <TableCell className='encabezado'>Tema</TableCell>
              <TableCell className='encabezado'>Indicador</TableCell>
              <TableCell className='encabezadoOp'>Opciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedResults.map((row, index) => (
              <TableRow className='tabla' key={index}>
                <TableCell className='itemtable'>{row.area}</TableCell>
                <TableCell className='itemtable'>{row.tema}</TableCell>
                <TableCell className='itemtableI'>{row.indicador}</TableCell>
                <TableCell className='Opciones'>
                  <ModalResultados Idindicador={row.id} indicador={row} width={1290} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 150]}
        component="div"
        count={paginatedData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página:"
      />
    </div>
  );
};
export { IndicadoresTable };
